import {observer} from "mobx-react-lite";
import React from "react";
import './day-off-statistics.scss';
import {DayOffUserStore, TOTAL_DAY_OFF_PER_MEMBER} from "./store/day-off-user-store";
import {dateTimeCell} from "../../components/ui/cells";
import {formatDayOffReasonEnum} from "./format-day-off-reason-enum";
import {mdiClose, mdiPlus} from "@mdi/js";
import {Button} from "../../components/ui";
import {DayOffStatusEnum} from "../../generated";

type Props = {
    store: DayOffUserStore;
}

export const DayOffStatistics = observer((props: Props) => {
    const { store } = props;

    return <div className={'day-off-statistics'}>
        <div>
            <h4 className={'day-off-status-title'}>Approved</h4>
            <span>{store.approvedDaysOffWithingCurrentYear.length}</span>
        </div>

        <div>
            <h4 className={'day-off-status-title'}>Remaining</h4>
            <span>{TOTAL_DAY_OFF_PER_MEMBER - store.approvedDaysOffWithingCurrentYear.length}</span>
        </div>

        <div>
            <h4 className={'day-off-status-title'}>Pending</h4>
            <ul className={'pending-days'}>
                {store.pendingDaysOffWithingCurrentYear.length === 0 && <span>None</span>}
                {store.pendingDaysOffWithingCurrentYear.map(dayOff => {
                    return <li className={'pending-day'} key={dayOff.id}>
                        <div className={'pending-day-date'}>{dateTimeCell(dayOff.date)}</div>
                        <div className={'pending-day-reason'}>{formatDayOffReasonEnum(dayOff.reason)}</div>
                        <div className={'pending-day-buttons'}>
                            <Button
                                disabled={store.isDayOffStatusChanging}
                                classes={'roundButton tertiaryBtn'}
                                icon={mdiPlus}
                                onClick={() => {
                                    store.changeDayOffStatus(dayOff, DayOffStatusEnum.Approved)
                                }}>
                                Approve
                            </Button>
                            <Button
                                disabled={store.isDayOffStatusChanging}
                                classes={'roundButton secondaryButton red'}
                                icon={mdiClose}
                                onClick={() => {
                                    store.changeDayOffStatus(dayOff, DayOffStatusEnum.Declined)
                                }}>
                                Decline
                            </Button>
                        </div>
                    </li>
                })}
            </ul>
        </div>
    </div>
})